import axios, {CancelTokenSource} from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {AXIOS_CANCEL_MSG, Performance, Quote,} from '../api/models';
import { ConfiguratorContext } from '../context';

interface PerformanceProps {
  //quoteId:string | undefined
  //revision?: number | undefined
  quote:Quote | undefined
}

const usePerformance = (props: PerformanceProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:PerformanceProps  ) : Promise<Performance | undefined> => {

    //const { quoteId, revision } = props;
    if (!props.quote) return;

    const { quoteId, revision } = props.quote;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchQuotePerformance(quoteId, revision, cancelSource?.token);
      cancelTokenSourceRef.current = undefined;
      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
        'fetchQuotePerformance',
        props
      ],
      ([_k, p]) => fetcher(p),
      {
        shouldRetryOnError: false,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        revalidateOnMount: true,
        dedupingInterval:1
    }
  );
};


export default usePerformance;

